import './Benefit.scss'

const Benefit = ({ icon, title, desc }) => {
  return (
    <div className="second-section-benefit">
      <div className="second-section-benefit-icon">
        {icon}
      </div>
      <div className="second-section-benefit-title">
        {title}
      </div>
      <div className="second-section-benefit-description">
        {desc}
      </div>

      <div className="benefit-border-right"></div>
      <div className="benefit-border-bottom"></div>
    </div>
  )
}

export default Benefit